import { reconciliationResultMessages } from "@/services/messages";
import type { RunRecord } from "@efes/shared";
import { CheckCircle2 } from "lucide-react";
import { ResultBanner } from "./ResultBanner";
import { countSeverity } from "./lib/view-model";

/**
 * Empty-state «0 расхождений» (T058, FR-019).
 *
 * Нейтральная подача БЕЗ эмоций (профессиональный инструмент):
 * - `CheckCircle2` зелёная (large), `bg-emerald-50` (assumption #8);
 * - title «Все позиции совпадают», subtitle «Сверка завершена без расхождений»;
 * - сводка прогона (`ResultBanner`) — отображается;
 * - CTA «Закрыть отчёт» (если onClose передан).
 *
 * Не использует эмодзи, восклицательные знаки, поздравления (FR-019).
 */
export interface EmptyStateProps {
	run: RunRecord;
	setName: string;
	onClose?: () => void;
}

export function EmptyState({ run, setName, onClose }: EmptyStateProps) {
	const messages = reconciliationResultMessages.empty;
	const counters = countSeverity([]);

	return (
		<div className="space-y-4">
			<ResultBanner run={run} setName={setName} counters={counters} />

			<section className="rounded-lg border border-emerald-200 bg-emerald-50 px-6 py-12 text-center">
				<CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" aria-hidden="true" />
				<h2 className="mt-4 text-lg font-semibold text-emerald-900">{messages.title}</h2>
				<p className="mt-1 text-sm text-emerald-700">{messages.subtitle}</p>

				{onClose && (
					<button
						type="button"
						onClick={onClose}
						className="mt-6 inline-flex items-center rounded-lg border border-emerald-300 bg-white px-4 py-2 text-sm font-medium text-emerald-700 transition-colors hover:bg-emerald-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
					>
						{messages.close_cta}
					</button>
				)}
			</section>
		</div>
	);
}
